import styled from "styled-components";
import * as M from "@discovery/prelude/lib/data/maybe";
import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
import { RenderMaybe } from "@discovery/components-luna-react/lib/utils/render-maybe";
import { Fold, Traversal } from "@discovery/prelude/lib/control/lens";
import * as Optics from "@discovery/sonic-api-ng-optics";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { primaryFontFamilyBold } from "../../styles/fontFamilyTypes";
import { neutral10 } from "../../css/colors";
import { SonicImage } from "../../components/atoms/sonic-image";
import { media } from "../../styles/breakpoints";
const BASIC = "basic";
const _Imagedata = Fold.compose(Optics._Col2Items, Fold.compose(Optics._ColItem2Image, Traversal._filteredOn(Res._Response(), (image) => image.attributes.kind === "default"), Res._Response()));
export const Title = styled.span `
  font-family: ${primaryFontFamilyBold};
  font-size: 32px;
  color: ${neutral10};
  text-align: center;
  padding: 135px 0px 35px 0px;
  line-height: 1.37;
  @media ${media.medium.up} {
    max-width: 72vw;
  }
  @media ${media.medium.down} {
    font-size: 16px;
    padding: 24px 40px 16px 40px;
    width: 90vw;
    white-space: unset;
  }
`;
export const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const getProps = (data) => {
    const titleM = Fold.view(Optics._ColAttributes2Description, data);
    const templateIdM = Fold.preview(Optics._Col2TemplateId, data);
    const imagesM = Fold.preview(_Imagedata, data);
    return {
        titleM,
        templateIdM,
        imagesM,
    };
};
const PlatformPromotion = ({ titleM, templateIdM, imagesM }) => {
    const templateId = M.fromMaybe(templateIdM, "");
    const BasicView = () => {
        return (React.createElement(Container, null,
            React.createElement(RenderMaybe, null, M.map((title) => (title ? React.createElement(Title, null, title) : ""), titleM)),
            React.createElement(RenderMaybe, null, M.map((x) => (React.createElement(SonicImage, { image: x.attributes, className: "cover-image", imageSizes: {
                    default: [78, "vw"],
                    maxWidthMediaQueries: [[1920, "px", 100, "vw"]],
                }, fallbackImageSize: { width: 1920 }, alt: "cover" })), imagesM))));
    };
    switch (templateId) {
        case BASIC:
            return React.createElement(BasicView, null);
        default:
            return React.createElement(React.Fragment, null);
    }
};
export const ComponentMapItem = mkSiteBuilderComponent(getProps, PlatformPromotion);

